/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types,no-console,
react/no-danger,react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import ContentLoader from 'react-content-loader';
import { formatRoute } from 'react-router-named-routes';
import { withTranslation } from 'react-i18next';
// material-ui icons
import Edit from '@material-ui/icons/Edit';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Cancel from '@material-ui/icons/Cancel';
import FilterIco from '@material-ui/icons/FilterList';
import Refresh from '@material-ui/icons/Refresh';
import LinearProgress from '@material-ui/core/LinearProgress';
// material-ui/ core components
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import { Hidden, Tooltip, Zoom } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import { NOTIFICATION_TYPE } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import Paginator from 'components/common/Paginator';
import { TableLoader } from 'components/common/TableLoader';
import Filter from 'components/NotificationType/Filter';
import WithPermission from 'components/User/WithPermission';

/**
 * @description - NotificationTypeList component
 * @augments React.Component
 */
class NotificationTypeList extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      showFilters: false,
    };
  }

  /**
   * @description
   * Handle show collapsed or full filters.
   */
  handleShowFilters = () => {
    const { showFilters } = this.state;
    this.setState({ showFilters: !showFilters });
  };

  /**
   * @description
   * Redirect to notification_type/create route.
   */
  handleCreate = () => {
    const history = this.context;
    history.push(NOTIFICATION_TYPE.CREATE);
  };

  /**
   * @description
   * Redirect to notification_type/update route.
   *
   * @param {string} id - Id of the notification type to edit.
   */
  handleEdit = id => {
    const history = this.context;
    history.push(formatRoute(NOTIFICATION_TYPE.UPDATE, { id }));
  };

  /**
   * @description
   * Handle enable notification type.
   *
   * @param {string} id - Id of the notification type to enable.
   */
  handleEnable = id => {
    const { enableNotificationType, refresh } = this.props;
    enableNotificationType({ variables: { id } }).then(() => {
      refresh();
    });
  };

  /**
   * @description
   * Handle disable notification type.
   *
   * @param {string} id - Id of the notification type to disable.
   */
  handleDisable = id => {
    const { disableNotificationType, refresh } = this.props;
    disableNotificationType({ variables: { id } }).then(() => {
      refresh();
    });
  };

  /**
   * @description
   * Call refresh callback.
   */
  handleRefresh = () => {
    const { refresh } = this.props;
    refresh();
  };

  /**
   * @description
   * Render component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const {
      classes,
      t,
      data,
      loading,
      fullLoading,
      changeNumberOfRows,
      changePage,
      numberOfRowsSelected,
      paginationDirection,
      appliedFilter,
      filter,
    } = this.props;
    const { showFilters } = this.state;

    const edges =
      loading || data === undefined ? [] : data.adminNotificationTypes.edges;

    return (
      <GridContainer>
        <GridItem xs={12}>
          <div className={classes.pageContainer}>
            <GridContainer justify="space-between" alignItems="center">
              <GridItem>
                <h3 className={classes.title}>
                  {t('notification_type.list.title')}
                </h3>
              </GridItem>

              <GridItem>
                <Button
                  color="primary"
                  simple
                  onClick={this.handleRefresh}
                  id="refresh"
                  key="refresh"
                >
                  <Refresh />
                  {t('notification_type.filters.update')}
                </Button>
                <WithPermission allowPermissions={['add_notificationtype']}>
                  <Button
                    data-cy="createNotificationType"
                    color="success"
                    default
                    onClick={() => this.handleCreate()}
                    id="createNotificationType"
                    style={{ marginLeft: 16 }}
                  >
                    {t('notification_type.form.create')}
                  </Button>
                </WithPermission>
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12}>
                <div className={classes.contentContainer}>
                  <div
                    className={[
                      classes.loadingLineContainer,
                      classes.topLine,
                    ].join(' ')}
                  >
                    {' '}
                    {fullLoading && (
                      <LinearProgress
                        classes={{
                          barColorPrimary: classes.loadingLine,
                        }}
                      />
                    )}
                  </div>
                  <GridContainer
                    justify="space-between"
                    alignItems="center"
                    className={classes.loteActionsAnimation}
                  >
                    <GridItem xs={12} sm={8} md={7}>
                      <div className={classes.searchFieldContainer}>
                        <Button
                          color="info"
                          round
                          simple={!showFilters}
                          onClick={this.handleShowFilters}
                          id="filter"
                          key="filter"
                          data-cy="filterBtn"
                        >
                          <FilterIco />
                          <span>{t('notification_type.list.filter')}</span>
                        </Button>
                      </div>
                      <Hidden
                        only={['sm', 'md', 'lg', 'xl']}
                        implementation="css"
                      >
                        <GridContainer>
                          <GridItem xs={12}>
                            <div
                              className={`${classes.loteActionsAnimation}
                    ${
                      showFilters
                        ? classes.showPaidAdFilters
                        : classes.hideFilters
                    }`}
                            >
                              <Filter
                                filter={filter}
                                appliedFilter={appliedFilter}
                              />
                            </div>
                          </GridItem>
                        </GridContainer>
                      </Hidden>
                    </GridItem>
                    <GridItem xs={12} sm={4} md={5}>
                      {!fullLoading && data.adminNotificationTypes ? (
                        <Paginator
                          pageInfo={data.adminNotificationTypes.pageInfo}
                          changePage={changePage}
                          changeNumberOfRows={changeNumberOfRows}
                          paginationDirection={paginationDirection}
                          numberOfRowsSelected={numberOfRowsSelected}
                        />
                      ) : (
                        <ContentLoader height={67} width={327} speed={2}>
                          <path
                            // eslint-disable-next-line max-len
                            d="M199,16 L304,16 C307.313708,16 310,18.6862915 310,22 L310,46 C310,49.3137085 307.313708,52 304,52 L199,52 C195.686292,52 193,49.3137085 193,46 L193,22 C193,18.6862915 195.686292,16 199,16 Z M25.9861352,27.0121317 L70.0138648,27.0121317 C74.4244855,27.0121317 78,30.5876462 78,34.9982669 C78,39.4088876 74.4244855,42.9844021 70.0138648,42.9844021 L25.9861352,42.9844021 C21.5755145,42.9844021 18,39.4088876 18,34.9982669 C18,30.5876462 21.5755145,27.0121317 25.9861352,27.0121317 Z M103.986135,27.0121317 L148.013865,27.0121317 C152.424485,27.0121317 156,30.5876462 156,34.9982669 C156,39.4088876 152.424485,42.9844021 148.013865,42.9844021 L103.986135,42.9844021 C99.5755145,42.9844021 96,39.4088876 96,34.9982669 C96,30.5876462 99.5755145,27.0121317 103.986135,27.0121317 Z"
                            fill="#D8D8D8"
                          />
                        </ContentLoader>
                      )}
                    </GridItem>
                  </GridContainer>
                  <Hidden only={['xs']} implementation="css">
                    <GridContainer>
                      <GridItem xs={12}>
                        <div
                          className={`${classes.loteActionsAnimation}
                    ${
                      showFilters
                        ? classes.showPaidAdFilters
                        : classes.hideFilters
                    }`}
                        >
                          <Filter
                            filter={filter}
                            appliedFilter={appliedFilter}
                          />
                        </div>
                      </GridItem>
                    </GridContainer>
                  </Hidden>
                  <GridContainer>
                    <GridItem xs={12}>
                      {loading ? (
                        <TableLoader />
                      ) : (
                        <ReactTable
                          data={edges}
                          loading={loading}
                          columns={[
                            {
                              Header: t('notification_type.list.headers.info'),
                              accessor: 'node.id',
                              minWidth: 300,
                              Cell: row => (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      gap: '5px',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    {row.original.node.photo ? (
                                      <img
                                        src={row.original.node.photo}
                                        alt="notification"
                                        style={{
                                          width: 50,
                                          height: 50,
                                          objectFit: 'cover',
                                          borderRadius: '4px',
                                          flexShrink: 0,
                                        }}
                                      />
                                    ) : (
                                      <div
                                        style={{
                                          width: 50,
                                          height: 50,
                                          backgroundColor: '#e0e0e0',
                                          borderRadius: '4px',
                                          flexShrink: 0,
                                        }}
                                      />
                                    )}
                                    <span>ID: {row.value}</span>
                                    <span>{row.original.node.name}</span>
                                    <span>
                                      {row.original.node.category.name}
                                    </span>
                                    <span>{row.original.node.description}</span>
                                  </div>
                                </>
                              ),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.deliveryPush',
                              ),
                              accessor: 'node.enableSendPush',
                              minWidth: 120,
                              Cell: row =>
                                row.value
                                  ? t('notification_type.list.enabled')
                                  : t('notification_type.list.disabled'),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.deliveryEmail',
                              ),
                              accessor: 'node.enableSendEmail',
                              minWidth: 120,
                              Cell: row =>
                                row.value
                                  ? t('notification_type.list.enabled')
                                  : t('notification_type.list.disabled'),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.defaultSettingsPush',
                              ),
                              accessor: 'node.defaultUserSettingsPush',
                              minWidth: 150,
                              Cell: row =>
                                row.value
                                  ? t('notification_type.list.enabled')
                                  : t('notification_type.list.disabled'),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.defaultSettingsEmail',
                              ),
                              accessor: 'node.defaultUserSettingsEmail',
                              minWidth: 150,
                              Cell: row =>
                                row.value
                                  ? t('notification_type.list.enabled')
                                  : t('notification_type.list.disabled'),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.status',
                              ),
                              accessor: 'node.isActive',
                              minWidth: 100,
                              Cell: row => (
                                <span
                                  className={
                                    row.value
                                      ? classes.runningTag
                                      : classes.deletedTag
                                  }
                                >
                                  {row.value
                                    ? t('notification_type.list.enabled')
                                    : t('notification_type.list.disabled')}
                                </span>
                              ),
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.strategy',
                              ),
                              accessor: 'node.strategy',
                              minWidth: 100,
                            },
                            {
                              Header: t(
                                'notification_type.list.headers.example',
                              ),
                              accessor: 'node.example',
                              minWidth: 150,
                            },
                            {
                              Header: t('common.actions'),
                              accessor: 'actions',
                              sortable: false,
                              filterable: false,
                              minWidth: 100,
                              Cell: row => (
                                <div className="actions-right">
                                  <WithPermission
                                    allowPermissions={[
                                      'change_notificationtype',
                                    ]}
                                  >
                                    <Tooltip
                                      placement="top"
                                      TransitionComponent={Zoom}
                                      title={
                                        <React.Fragment>
                                          {t('common.edit')}
                                          <span className={classes.arrow} />
                                        </React.Fragment>
                                      }
                                      classes={{
                                        tooltip: classes.bootstrapTooltip,
                                        tooltipPlacementTop:
                                          classes.bootstrapPlacementTop,
                                      }}
                                    >
                                      <Button
                                        data-cy="notificationTypeUpdate"
                                        justIcon
                                        simple
                                        onClick={() =>
                                          this.handleEdit(row.original.node.id)
                                        }
                                        color="primary"
                                        className="edit"
                                        id={`edit-notification-type-${row.original.node.id}`}
                                      >
                                        <Edit />
                                      </Button>
                                    </Tooltip>
                                  </WithPermission>
                                  <WithPermission
                                    allowPermissions={[
                                      'change_notificationtype',
                                    ]}
                                  >
                                    {row.original.node.isActive ? (
                                      <Tooltip
                                        placement="top"
                                        TransitionComponent={Zoom}
                                        title={
                                          <React.Fragment>
                                            {t('common.disable')}
                                            <span className={classes.arrow} />
                                          </React.Fragment>
                                        }
                                        classes={{
                                          tooltip: classes.bootstrapTooltip,
                                          tooltipPlacementTop:
                                            classes.bootstrapPlacementTop,
                                        }}
                                      >
                                        <Button
                                          data-cy="notificationTypeDisable"
                                          justIcon
                                          simple
                                          onClick={() =>
                                            this.handleDisable(
                                              row.original.node.id,
                                            )
                                          }
                                          color="danger"
                                          className="disable"
                                          id={`disable-notification-type-${row.original.node.id}`}
                                        >
                                          <Cancel />
                                        </Button>
                                      </Tooltip>
                                    ) : (
                                      <Tooltip
                                        placement="top"
                                        TransitionComponent={Zoom}
                                        title={
                                          <React.Fragment>
                                            {t('common.enable')}
                                            <span className={classes.arrow} />
                                          </React.Fragment>
                                        }
                                        classes={{
                                          tooltip: classes.bootstrapTooltip,
                                          tooltipPlacementTop:
                                            classes.bootstrapPlacementTop,
                                        }}
                                      >
                                        <Button
                                          data-cy="notificationTypeEnable"
                                          justIcon
                                          simple
                                          onClick={() =>
                                            this.handleEnable(
                                              row.original.node.id,
                                            )
                                          }
                                          color="success"
                                          className="enable"
                                          id={`enable-notification-type-${row.original.node.id}`}
                                        >
                                          <CheckCircle />
                                        </Button>
                                      </Tooltip>
                                    )}
                                  </WithPermission>
                                </div>
                              ),
                            },
                          ]}
                          pageSize={edges.length}
                          showPagination={false}
                          className={['-striped -highlight', classes.tbl].join(
                            ' ',
                          )}
                        />
                      )}
                    </GridItem>
                  </GridContainer>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </GridItem>
      </GridContainer>
    );
  }
}

/**
 * NotificationTypeList PropTypes
 */
NotificationTypeList.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    adminNotificationTypes: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            id: PropTypes.string.isRequired,
            photo: PropTypes.string,
            name: PropTypes.string.isRequired,
            description: PropTypes.string,
            category: PropTypes.shape({
              id: PropTypes.string,
              name: PropTypes.string,
            }),
            enableSendPush: PropTypes.bool,
            enableSendEmail: PropTypes.bool,
            defaultUserSettingsEmail: PropTypes.bool,
            defaultUserSettingsPush: PropTypes.bool,
            isActive: PropTypes.bool,
            strategy: PropTypes.string,
            example: PropTypes.string,
          }),
        }),
      ),
      pageInfo: PropTypes.shape({
        hasNextPage: PropTypes.bool,
        hasPreviousPage: PropTypes.bool,
        startCursor: PropTypes.string,
        endCursor: PropTypes.string,
      }),
    }),
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  fullLoading: PropTypes.bool.isRequired,
  numberOfRowsSelected: PropTypes.number.isRequired,
  paginationDirection: PropTypes.string,
  changePage: PropTypes.func.isRequired,
  changeNumberOfRows: PropTypes.func.isRequired,
  appliedFilter: PropTypes.shape({}).isRequired,
  filter: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
  enableNotificationType: PropTypes.func.isRequired,
  disableNotificationType: PropTypes.func.isRequired,
};

NotificationTypeList.defaultProps = {
  paginationDirection: null,
};

export default withTranslation()(
  withStyles(extendedTablesStyle)(NotificationTypeList),
);
